export default "__VITE_ASSET__CtXlJZD4__"